import type { Reducer } from 'redux';
import { combineReducers } from 'redux';
import { reducer as userReducer } from 'b2b-apps/shop/myAccount/users/redux/user/reducer';
import { reducer as usersReducer } from 'b2b-apps/shop/myAccount/users/redux/users/reducer';
import type { UsersAction, UsersState } from './types';

const reducer: Reducer<UsersState, UsersAction> = combineReducers<any, any>({
  users: usersReducer,
  user: userReducer,
});

export { reducer };
